<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--wait_for_date">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">WAIT FOR DATE</div>
        <div class="workflow-node__title">{{ data?.config?.date_field || 'Date field' }}</div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
